import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "@providers/AuthContext";
import { kLocalStorageKeys } from "@utils/constants/kLocalStorageKeys";
import LoadingView from "@components/common/LoadingView";
import { ExperimentProperties, useExperiment } from "@providers/ExperimentContext";
import { usePremium } from "@providers/PremiumContext";

const ProfileSetupRoute = () => {
	const { authUser } = useAuth();
    const { fetchProperty } = useExperiment();
	const { isPremium } = usePremium();
    
    if (!authUser?.is_profile_setup) {
        return <Navigate to={{ pathname: "/login" }} />;
    }

    const isPaidOnly = fetchProperty(ExperimentProperties.isPaidOnly);

    if (isPaidOnly && !isPremium()) {
        return <Navigate to="/unlock-meco" state={{ isNoOnboarding: Boolean(true) }} />;
    }

	return <Outlet />;
};

export default ProfileSetupRoute;